
export class BasePageRequest {
    pageNumber: any;
    size: any;
    sortColumn: any;
    sortDirection: any;
    constructor(pageNumber: any, size: any, sortColumn: any, sortDirection: any) {
        this.pageNumber = pageNumber;
        this.size = size;
        this.sortColumn = sortColumn;
        this.sortDirection = sortDirection ;
    }
}
